import { Injectable } from '@angular/core';

import { map, Observable, of } from 'rxjs';

import { State } from '@reg/shared/model';
import { HttpServiceHelper } from '@reg/shared/service/http-service-helper';
import { IJsonApiResponse } from '../json-api/json-api.interface';
import { observableInSeparateThread } from '../helper/observable-helper';

/**
 * Service to get states
 */
@Injectable()
export class StateService {
    public static COUNTRY_ID_USA: string = '3643adc1-8d66-4b14-a987-c119cd3912be';

    private cachedStates: State[] = null;

    /**
     * Constructor
     */
    constructor(private http: HttpServiceHelper) {
    }

    /**
     * Get all states
     */
    public getIndex(country: string, forceRefresh: boolean = false): Observable<State[]> {
        if (!forceRefresh &&
            this.cachedStates) {
            // if `cachedStates` is available just return it as `Observable`
            return observableInSeparateThread(this.cachedStates.map((x: State) => x.clone()));
        }
        // Make the http request
        const apiUrl: string = `${this.http.configService.getApiBaseUrl()}/countries/${country}/states/`;

        return this.http.get(apiUrl)
            .pipe(map((response: IJsonApiResponse) => {
                const states: State[] = [];
                const bodyData: any = response.data || [];
                for (const state of bodyData) {
                    states.push((new State()).deserialize(state));
                }
                this.cachedStates = states;
                return this.cachedStates.map((x: State) => x.clone());
            }));
    }
}
